import styled from '@emotion/styled'
import { FormControl, TextField } from '@mui/material'
import Button from '../../../Buttons/Button'
import { MOBILE_BREAKPOINT, maxWindowWidth } from '../../../styles/breakpoints'
import { palette } from '../../../styles/colors'
import { APP_FONT } from '../../../theme'

export const Container = styled('div')({
    padding: '16px 16px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    fontFamily: APP_FONT,
})

export const Section = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
})

export const Divider = styled('hr')({
    border: 'none',
    height: '1px',
    backgroundColor: palette.drawerDivider,
    width: '100%',
    margin: '8px 0 2px',
})

export const Row = styled('div')({
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
})

export const FileInputContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
})

export const FileInputLabel = styled('label')({
    backgroundColor: palette.backgroundLightGray,
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer',
    display: 'inline-block',
    textTransform: 'uppercase',
    color: palette.primaryText,
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: palette.backgroundLightGray2,
    },
})

export const FileNameDisplay = styled('div')({
    padding: '4px 0',
    fontSize: 13,
    color: palette.secondaryText,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
})

export const HiddenInput = styled('input')({
    display: 'none',
})

export const HeaderText = styled('div')({
    fontSize: 13,
    fontWeight: 700,
    color: palette.primaryText,
})

export const LabelText = styled('span')({
    fontSize: 13,
    color: palette.primaryText,
    minWidth: 130,
})

export const StyledButton = styled(Button)({
    fontSize: 12,
    padding: '6px 16px',
    height: 36,
    whiteSpace: 'nowrap',
    [maxWindowWidth(MOBILE_BREAKPOINT)]: {
        minWidth: 100,
        fontSize: 11,
        padding: '6px 12px',
    },
})

export const StyledTextField = styled(TextField)({
    flexGrow: 1,
    '& .MuiOutlinedInput-root': {
        fontFamily: APP_FONT,
        height: '36px',
        fontSize: '0.875rem',
    },

    '& .MuiOutlinedInput-input': {
        padding: '8px 14px',
        '&::placeholder': {
            color: palette.disabledText,
        },
    },
})

export const StyledSelect = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        height: '36px',
        fontSize: '0.875rem',
        fontFamily: APP_FONT,
    },

    '& .MuiSelect-select': {
        fontFamily: APP_FONT,
        padding: '8px 14px',
    },
})

export const ButtonContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '6px',
    marginBottom: '8px',
})

export const isValidUrl = (url: string) => {
    try {
        new URL(url)
        return true
    } catch (_e) {
        return false
    }
}
